<template>
  <section>
    <div class="row">
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-9 col-12">
        <h4>Queues</h4>
      </div>
    </div>
    <div class="row">
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Worker"
          title="Worker"
          :value="worker"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Background"
          title="Background"
          :value="background"
        >
        </dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Postback"
          title="Postback"
          :value="postback"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Mitglieder"
          title="Mail Mitglieder"
          :value="mailCustomer"
        >
        </dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Rundmail"
          title="Mail Rundmail"
          :value="mailCircular"
        >
        </dashboard-info-card>
      </div>
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Benachrichtigungen"
          title="Mail Benachrichtigungen"
          :value="mailNotification"
        >
        </dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Bezahlung"
          title="Mail Bezahlung"
          :value="mailPayment"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Support"
          title="Mail Support"
          :value="mailSupport"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Mail Admin"
          title="Mail Admin"
          :value="mailAdmin"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="FkeGenDynPLZ"
          title="FkeGenDynPLZ"
          :value="fkeGenDynPLZ"
        ></dashboard-info-card>
      </div>
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Profile Visits"
          title="Profile Visits"
          :value="profileVisits"
        >
        </dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Rundmail"
          title="Rundmail"
          :value="circularmail"
        >
        </dashboard-info-card>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-9 col-12">
        <h4>Versionen</h4>
      </div>
    </div>
    <div class="row">
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Nginx"
          title="Nginx"
          :value="nginx"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card id="Redis" title="Redis" :value="redis">
        </dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="MariaDB"
          title="MariaDB"
          :value="mariaDB"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="yarn"
          title="yarn"
          :value="yarn"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Node.js"
          title="Node.js"
          :value="nodeJs"
        ></dashboard-info-card>
      </div>
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="npm"
          title="npm"
          :value="npm"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="PHP"
          title="PHP"
          :value="php"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Composer"
          title="Composer"
          :value="composer"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="ffmpeg"
          title="ffmpeg"
          :value="ffmpeg"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="OS"
          title="OS"
          :value="os"
        ></dashboard-info-card>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-9 col-12">
        <h4>Auslastung</h4>
      </div>
    </div>
    <div class="row">
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="RAM"
          title="RAM"
          :value="usedRam"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="CPU"
          title="CPU"
          :value="usedCpu"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="Redis RAM"
          title="Redis RAM"
          :value="redisMemoryUsed"
        ></dashboard-info-card>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-9 col-12">
        <h4>Mailversand</h4>
      </div>
    </div>
    <div class="row">
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="heute"
          title="heute"
          :value="thisDay"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="diese Woche"
          title="diese Woche"
          :value="thisWeek"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="diesen Monat"
          title="diesen Monat"
          :value="thisMonth"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="letzten Monat"
          title="letzten Monat"
          :value="lastMonth"
        ></dashboard-info-card>
      </div>
    </div>
  </section>
</template>

<script>
import DashboardInfoCard from "src/components/UIComponents/Cards/DashboardInfoCard";
import moment from "moment";
export default {
  components: {
    DashboardInfoCard
  },
  data() {
    return {
      canFetch: true,
      background: 0,
      mailAdmin: 0,
      mailNotification: 0,
      mailPayment: 0,
      mailCustomer: 0,
      mailCircular: 0,
      mailSupport: 0,
      postback: 0,
      worker: 0,
      fkeGenDynPLZ: 0,
      profileVisits: 0,
      circularmail: 0,
      composer: "",
      mariaDB: "",
      nginx: "",
      nodeJs: "",
      os: "",
      php: "",
      redis: "",
      ffmpeg: "",
      npm: "",
      yarn: "",
      usedCpu: 0,
      usedRam: 0,
      redisMemoryUsed: "",
      thisDay: 0,
      thisMonth: 0,
      lastMonth: 0,
      thisWeek: 0
    };
  },
  methods: {
    getQueueStats() {
      return this.$http
        .get("/api/v1/superadminDashboard/queueSize")
        .then(({ data }) => {
          this.background = data["Background"];
          this.worker = data["Default"];
          this.fkeGenDynPLZ = data["FkeGenDynPLZ"];
          this.mailAdmin = data["Mail Admin"];
          this.mailNotification = data["Mail Benachrichtigungen"];
          this.mailPayment = data["Mail Bezahlung"];
          this.mailCustomer = data["Mail Mitglieder"];
          this.mailCircular = data["Mail Rundmail"];
          this.mailSupport = data["Mail Support"];
          this.postback = data["Postback"];
          this.profileVisits = data["Profile Visits"];
          this.circularmail = data["Rundmail"];
        });
    },
    getVersions() {
      return this.$http
        .get("/api/v1/superadminDashboard/getVersions")
        .then(({ data }) => {
          this.composer = data["Composer"];
          this.mariaDB = data["MariaDB"];
          this.nginx = data["Nginx"];
          this.nodeJs = data["Node.js"];
          this.os = data["OS"];
          this.php = data["PHP"];
          this.redis = data["Redis"];
          this.ffmpeg = data["ffmpeg"];
          if (data["ffmpeg"].indexOf("Copyright") != -1) {
            this.ffmpeg = data["ffmpeg"].substring(
              0,
              data["ffmpeg"].indexOf("Copyright")
            );
          }
          this.npm = data["npm"];
          this.yarn = data["yarn"];
        });
    },
    getStatistic() {
      return this.$http
        .get("/api/v1/superadminDashboard/getVersions")
        .then(({ data }) => {
          this.composer = data["Composer"];
          this.mariaDB = data["MariaDB"];
          this.nginx = data["Nginx"];
          this.nodeJs = data["Node.js"];
          this.os = data["OS"];
          this.php = data["PHP"];
          this.redis = data["Redis"];
          this.ffmpeg = data["ffmpeg"];
          this.npm = data["npm"];
          this.yarn = data["yarn"];
        });
    },
    getUsedCPU() {
      return this.$http
        .get("/api/v1/superadminDashboard/statistic", {
          params: {
            since: moment()
              .subtract(90, "seconds")
              .format("YYYY-MM-DD HH:mm:ss"),
            to: moment().format("YYYY-MM-DD HH:mm:ss"),
            entity: "cpu"
          }
        })
        .then(({ data }) => {
          let max = 0;
          for (var property in data) {
            max = max < parseFloat(property) ? parseFloat(property) : max;
          }
          this.usedCpu = Math.round(data[max]) + "%";
        });
    },
    getUsedRAM() {
      return this.$http
        .get("/api/v1/superadminDashboard/statistic", {
          params: {
            since: moment()
              .subtract(90, "seconds")
              .format("YYYY-MM-DD HH:mm:ss"),
            to: moment().format("YYYY-MM-DD HH:mm:ss"),
            entity: "ram"
          }
        })
        .then(({ data }) => {
          let max = 0;
          for (var property in data) {
            max = max < parseFloat(property) ? parseFloat(property) : max;
          }
          this.usedRam = Math.round(data[max]) + "%";
        });
    },
    getRedisMemoryUsed() {
      return this.$http
        .get("/api/v1/superadminDashboard/getRedisMemoryUsed")
        .then(({ data }) => {
          this.redisMemoryUsed = Math.round(data / (1024 * 1024));
        });
    },
    getMailStats() {
      return this.$http
        .get("/api/v1/superadminDashboard/mailStats")
        .then(({ data }) => {
          this.lastMonth = data["lastMonth"];
          this.thisDay = data["thisDay"];
          this.thisMonth = data["thisMonth"];
          this.thisWeek = data["thisWeek"];
        });
    },
    fetchData() {
      if (this.canFetch) {
        this.canFetch = false;
        return Promise.all([
          this.getVersions(),
          this.getQueueStats(),
          this.getUsedCPU(),
          this.getUsedRAM(),
          this.getRedisMemoryUsed(),
          this.getMailStats()
        ]).finally(() => (this.canFetch = true));
      }
    }
  },
  created() {
    this.fetchData();
    this.fetchInterval = setInterval(() => {
      this.fetchData();
    }, 3500);
    this.reloadTimeout = setTimeout(() => {
      location.reload(true);
    }, 300000);
  },
  beforeDestroy() {
    this.canFetch = false;
    clearTimeout(this.reloadTimeout);
    clearInterval(this.fetchInterval);
  }
};
</script>
